/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type BabylonRelayerListRequest = {
    period?: BabylonRelayerListRequest.period;
    sortField?: BabylonRelayerListRequest.sortField;
    sortDirection?: BabylonRelayerListRequest.sortDirection;
    term?: string;
    page?: number;
    size?: number;
};

export namespace BabylonRelayerListRequest {

    export enum period {
        D7 = 'D7',
        D30 = 'D30',
        D90 = 'D90',
    }

    export enum sortField {
        RECEIVE_TRX_COUNT = 'RECEIVE_TRX_COUNT',
        SEND_TRX_COUNT = 'SEND_TRX_COUNT',
        TOTAL_TRX_COUNT = 'TOTAL_TRX_COUNT',
    }

    export enum sortDirection {
        ASC = 'ASC',
        DESC = 'DESC',
    }


}

